/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {SelectItem} from "primeng/api";
import { SelectItemsVoModel } from "@well/common-libs/select-items/domain";

@Pipe({
    name: 'addAllSelectItemOption'
})
@Injectable()
export class AddAllSelectItemOptionPipe implements PipeTransform {
    transform(value: SelectItemsVoModel[], labelProperty = 'All'): SelectItem[] {
      const clonedValue = Object.assign([], value);
        if (clonedValue) {
            if (clonedValue[0] === undefined || clonedValue[0].value !== null) {
              clonedValue.unshift({key: null, defaultLabel: labelProperty});
            }
            return clonedValue;
        }
    }
}
